"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _useVisibilityHook2 = _interopRequireDefault(require("../useVisibilityHook"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Bookmark = function Bookmark(props) {
  var content = props.content,
    language = props.language,
    setCurrentFlowAndEntity = props.setCurrentFlowAndEntity;
  var _useVisibilityHook = (0, _useVisibilityHook2["default"])(props),
    isClickable = _useVisibilityHook.isClickable,
    isVisible = _useVisibilityHook.isVisible;
  if (!isVisible) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  }
  var entityId = 0;
  var displayText = '';
  var iconUrl = '';
  if (language === 'en') {
    var _content$iconEn;
    entityId = content.entityIdEn;
    if ('headingEn' in content) {
      displayText = content.headingEn;
    }
    if ('iconEn' in content && content !== null && content !== void 0 && (_content$iconEn = content.iconEn) !== null && _content$iconEn !== void 0 && _content$iconEn.thumbnailSmall) {
      iconUrl = content.iconEn.thumbnailSmall;
    }
  }
  if (language === 'es') {
    var _content$iconEs;
    entityId = content.entityIdEs;
    if ('headingEs' in content) {
      displayText = content.headingEs;
    }
    if ('iconEs' in content && content !== null && content !== void 0 && (_content$iconEs = content.iconEs) !== null && _content$iconEs !== void 0 && _content$iconEs.thumbnailSmall) {
      iconUrl = content.iconEs.thumbnailSmall;
    }
  }
  if (!entityId || entityId <= 0 || !displayText) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  }
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("a", {
    href: "#",
    className: "".concat(_style["default"].bookmarkLink, " ").concat(isClickable ? '' : _style["default"].disabled),
    disabled: !isClickable,
    onClick: function onClick(event) {
      event.preventDefault();
      if (isClickable) {
        setCurrentFlowAndEntity(content.surveyHandle, entityId);
      }
    }
  }, iconUrl && /*#__PURE__*/_react["default"].createElement("img", {
    alt: "Bookmark Icon",
    src: iconUrl,
    className: _style["default"].icon
  }), /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: displayText
  })));
};
var _default = exports["default"] = Bookmark;